import PolicyDocPage from "@/components/PolicyDocPage";

const SECTIONS = [
  {
    n: 1,
    title: "Loan Application Cancellation by Borrower",
    paragraphs: [
      "A Borrower may request cancellation of a loan application before the loan is disbursed. Such requests must be made in writing (via email or letter) to Sahyog Finance.",
      "Upon receipt of a valid cancellation request before disbursement, the application shall be treated as withdrawn and no further processing shall be undertaken.",
    ],
  },
  {
    n: 2,
    title: "Processing Fees and Non-Refundable Charges",
    paragraphs: ["The following charges are generally non-refundable once paid or incurred:"],
    bullets: [
      "Loan processing fees / administrative charges",
      "Documentation charges",
      "Credit bureau report charges",
      "Valuation or inspection charges (if applicable)",
    ],
  },
  {
    n: 3,
    title: "Cancellation After Disbursement",
    paragraphs: [
      "Once the loan amount has been disbursed into the Borrower's designated bank account, the loan cannot be cancelled. The Borrower remains fully liable to repay the outstanding principal, interest and all applicable charges as per the terms of the Loan Agreement and the repayment schedule.",
    ],
  },
  {
    n: 4,
    title: "Prepayment and Foreclosure",
    paragraphs: [
      "Borrowers who wish to close their loan early may do so by making full prepayment (foreclosure). Prepayment is subject to the terms mentioned in the Loan Agreement, including applicable Prepayment Charges / Foreclosure Charges as specified by Sahyog Finance. The outstanding balance will be calculated as per the prevailing repayment schedule on the date of prepayment.",
    ],
  },
  {
    n: 5,
    title: "Refund of Excess Payments",
    paragraphs: [
      "If any excess amount is received from the Borrower (due to overpayment, duplicate payment or error), Sahyog Finance shall adjust the excess amount against future dues or refund it to the Borrower's registered bank account within a reasonable time after verification. The Borrower must provide correct bank details for such refunds.",
    ],
  },
  {
    n: 6,
    title: "Rejection of Loan Application by Lender",
    paragraphs: [
      "Sahyog Finance reserves the absolute right to reject any loan application at any stage without assigning any reason. In such cases, any processing fees or charges already paid may be refunded at the sole discretion of the Lender, after deducting actual expenses incurred (such as credit report charges, documentation costs, etc.).",
    ],
  },
  {
    n: 7,
    title: "Cooling-off Period",
    paragraphs: [
      "Sahyog Finance does not currently offer a general cooling-off period for loan products. However, in specific cases where required by applicable regulations or internal policy, a limited cooling-off window may be communicated separately to the Borrower at the time of sanction.",
    ],
  },
  {
    n: 8,
    title: "Force Majeure and Exceptional Circumstances",
    paragraphs: [
      "In case of cancellation due to circumstances beyond the control of either party (such as regulatory changes, natural disasters or technical failures preventing disbursement), Sahyog Finance shall handle such cases fairly and may consider partial or full waiver of charges on a case-to-case basis.",
    ],
  },
  {
    n: 9,
    title: "Grievance Redressal",
    paragraphs: [
      "For any queries or disputes related to cancellation or refund, please contact our Grievance Officer at the address shown below.",
    ],
  },
  {
    n: 10,
    title: "Policy Updates",
    paragraphs: [
      "Sahyog Finance reserves the right to modify this Cancellation & Refund Policy at any time. Updated versions will be made available on our website and shall apply to all applications received after the date of update.",
    ],
  },
];

export default function RefundPolicy() {
  return (
    <PolicyDocPage
      testId="refund-policy-page"
      eyebrow="Sahyog Finance · Legal"
      title={
        <>
          Cancellation &amp; <em className="not-italic text-[#D4AF37]">Refund Policy</em>
        </>
      }
      intro="This Cancellation and Refund Policy outlines the terms under which loan applications and related services provided by Sahyog Finance may be cancelled, and the conditions for any applicable refunds or adjustments."
      sections={SECTIONS}
      lastUpdated="June 2026"
    />
  );
}
